import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import WaiterDashboard from './pages/WaiterDashboard';
import ChefDashboard from './pages/ChefDashboard';
import ManagerDashboard from './pages/ManagerDashboard';
import { Provider } from 'react-redux';
import { store } from './store';

const DashboardRoute = () => {
                const token = localStorage.getItem('token');
                if (token) {
                  try {
                    const payload = JSON.parse(atob(token.split('.')[1]));
      switch (payload.role) {
        case 'admin':
          return <Dashboard />;
        case 'server':
          return <WaiterDashboard />;
        case 'chef':
          return <ChefDashboard />;
        case 'manager':
          return <ManagerDashboard />;
        default:
          return <Navigate to="/login" replace />;
      }
    } catch {
                    return <Navigate to="/login" replace />;
                  }
                }
                return <Navigate to="/login" replace />;
};

const App: React.FC = () => (
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<DashboardRoute />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
    </BrowserRouter>
    </Provider>
  );

export default App; 